import axios from "axios";
import { apicall } from "../../services/api";
import {
	GET_VOUCHERS,
	DELETE_VOUCHERS,
	GET_BATCH,
	GET_BATCHES,
	ADD_BATCH,
	UPDATE_BATCH,
	REMOVE_BATCH,
	ERR_BATCH,
	ERR_VOUCHERS,
	LOADING_VOUCHERS,
} from "./actionTypes";
import axiosInstance from "../../utils/axiosInterceptor";
import { toast } from "react-hot-toast";
import { reducersActions } from "./new-actions";

export const baseURL = `${process.env.REACT_APP_BASE_URL_VMS}/api/v1/`;
export const baseURLV3 = `${process.env.REACT_APP_BASE_URL_VMS}/api/v3/`;

const {
	GET_BATCHES_REQUEST,
	GET_BATCHES_SUCCESS,
	GET_BATCHES_FAILURE,
} = reducersActions;

export const getAllVoucherBatch = () => async (dispatch) => {
	try {
		const res = await apicall(`voucher_batch/`, "get");
		if (res.data.msg === "No data found.") {
			dispatch({
				type: GET_BATCHES,
				payload: res.data.data,
			});
		} else {
			dispatch({
				type: GET_BATCHES,
				payload: res.data,
			});
		}
	} catch (err) {
		dispatch({
			type: ERR_BATCH,
			payload: { msg: err.response.msg, status: err.response.status },
		});
	}
};

export const getAllVoucherBatchV3 = (page = 1, limit = 10, filters = {}) => async (dispatch) => {
	dispatch({ type: GET_BATCHES_REQUEST });

	try {
		const query = new URLSearchParams({ page, limit, ...filters }).toString();

		const res = await apicall(`voucher_batch?${query}`, "get", null, {}, "v3");

		dispatch({
			type: GET_BATCHES_SUCCESS,
			payload: res.data?.data || [],
		});
	} catch (err) {
		dispatch({
			type: GET_BATCHES_FAILURE,
			payload: {
				msg: err.response?.data?.msg || "Something went wrong",
				status: err.response?.status || 500,
			},
		});
	}
};


export const getVoucherBatch = (batchId) => async (dispatch) => {
	try {
		const res = await apicall(`voucher_batch/${batchId}`, "get");
		dispatch({
			type: GET_BATCH,
			payload: res.data,
		});
	} catch (err) {
		dispatch({
			type: ERR_BATCH,
			payload: { msg: err.response.msg, status: err.response.status },
		});
	}
};

export const createVoucherBatch = (formData) => async (dispatch) => {
	try {
		// const config = {
		// 	headers: {
		// 		"Content-Type": "multipart/form-data",
		// 		"Access-Control-Allow-Origin": "*",
		// 		accessToken: localStorage.getItem("accessToken"),
		// 	},
		// };
		// const res = await apicall("voucher_batch", "post", formData);
		const path = `voucher_batch`
		const res = await axiosInstance({
			method: "post",
			url: baseURL + path,
			data: formData,
			headers: {
				"Content-Type": "multipart/form-data",
				"Access-Control-Allow-Origin": "*",
				"accessToken": localStorage.getItem("accessToken"),
			}
		});
		// console.log("Batch", res);
		dispatch({
			type: ADD_BATCH,
			payload: res.data,
		});
		dispatch({
			type: ERR_BATCH,
			payload: {
				msg: "Voucher batch created successfully!",
				status: res.status,
			},
		});
		dispatch(getAllVoucherBatch());
		dispatch(showLoading(false));
	} catch (err) {
		dispatch({
			type: ERR_BATCH,
			payload: { msg: err.message, status: err.response.status },
		});
		dispatch(showLoading(false));
	}
};
export const createVoucherBatchV3 = (formData) => async (dispatch) => {
	try {
		const path = `voucher_batch`
		const res = await axiosInstance({
			method: "post",
			url: baseURLV3 + path,
			data: formData,
			headers: {
				"Content-Type": "multipart/form-data",
				"Access-Control-Allow-Origin": "*",
				"accessToken": localStorage.getItem("accessToken"),
			}
		});

		// console.log("Batch", res);
		dispatch({
			type: ADD_BATCH,
			payload: res.data,
		});
		dispatch(getAllVoucherBatchV3(1, 10, {}, true));
		toast.success("Batch created successfully!");
		return res
	} catch (err) {
		dispatch({
			type: ERR_BATCH,
			payload: { msg: err?.response?.data, status: err.response.status },
		});
		dispatch(showLoading(false));

		if (err?.response?.data?.message) {
			toast.error(err?.response?.data?.message);
		}
		return err?.response?.data
	}
};

export const updateVoucherBatch = (batchId, formData, type) => async (dispatch) => {
	try {
		if (formData.hasOwnProperty("brand_name")) {
			delete formData.brand_name;
		}
		let status;
		if (type === "voucher-update") {
			status = "voucher-update"
		} else {
			status = "status"
		}
		const path = `voucher_batch/${batchId}/${status}`
		const res = await apicall(path, "patch", formData, {}, "v3");

		dispatch(getAllVoucherBatchV3(1, 10, {}, true));
		dispatch({
			type: ERR_BATCH,
			payload: { msg: "Voucher batch update successfully!", status: res.status },
		});
		dispatch(showLoading(false));
		toast.success("Batch updated successfully!");
	} catch (err) {
		// const errors = err.response.data.errors;

		// if (errors) {
		// 	errors.forEach((error) =>
		// 		dispatch(setAlert(error.msg, "danger", 5000))
		// 	);
		// }
		dispatch({
			type: ERR_BATCH,
			payload: { msg: err.message, status: err.response.status },
		});
		dispatch(showLoading(false));
	}
};

export const deleteVoucherBatch = (batchId, modified_by) => async (dispatch) => {

	try {
		// const res = await apicall(`voucher_batch/${batchId}`, "delete", {"modified_by":modified_by});
		const path = `voucher_batch/${batchId?.batch_id}`
		const res = await axiosInstance({
			method: "delete",
			url: baseURL + path,
			data: { "modified_by": modified_by },
			headers: {
				"Content-Type": "application/json;charset=UTF-8",
				"Access-Control-Allow-Origin": "*",
				"accessToken": localStorage.getItem("accessToken"),
			}
		});
		// console.log("deleteRed:",res);

		dispatch({ type: REMOVE_BATCH, payload: batchId });
		dispatch({
			type: ERR_BATCH,
			payload: {
				msg: "Voucher batch deleted successfully!",
				status: res.status,
			},
		});
		toast.success("Batch deleted successfully!");
		dispatch(getAllVoucherBatchV3(1, 10, {}, true));
	} catch (err) {
		dispatch({
			type: ERR_BATCH,
			payload: { msg: err, status: err.response.status },
		});
		toast.error("Failed to delete batch. Please try again.");
	}
}

export const getVoucherCodes = (batchId, page, limit) => async (dispatch) => {
	try {

		// const res = await apicall(`voucher_batch/vouchers/${batchId}`, "get");
		// console.log(res.data);
		const options = {
			headers: {
				"Content-Type": "application/json;charset=UTF-8",
				"Access-Control-Allow-Origin": "*",
				"accessToken": localStorage.getItem("accessToken"),
			},
		};
		const path = `voucher_batch/${batchId}${page ? `?page=${page}&limit=${limit}` : ''}`;
		const res = await apicall(path, "get", null, options, "v3");

		dispatch({
			type: GET_VOUCHERS,
			payload: res.data?.data,
		});
	} catch (err) {
		dispatch({
			type: ERR_VOUCHERS,
			payload: { msg: err, status: err.response.status },
		});
	}
};

export const deleteVoucherCode = (voucherId) => async (dispatch) => {
	if (window.confirm("Are you sure? This can NOT be undone!")) {
		try {
			const res = await apicall(
				`voucher_batch/vouchers/voucher/${voucherId}`,
				"delete"
			);
			dispatch({ type: DELETE_VOUCHERS, payload: voucherId });
			dispatch({
				type: ERR_VOUCHERS,
				payload: { msg: "Voucher deleted successfully!", status: res.status },
			});
		} catch (err) {
			dispatch({
				type: ERR_VOUCHERS,
				payload: { msg: err, status: err.response.status },
			});
		}
	}
};

// actions/voucher.actions.js
export const deleteVoucherCodeV3 = (voucherId) => async (dispatch) => {
	try {
		const res = await apicall(
			`voucher_batch/vouchers/voucher/${voucherId}`,
			"delete"
		);
		dispatch({ type: DELETE_VOUCHERS, payload: voucherId });
		dispatch({
			type: ERR_VOUCHERS,
			payload: { msg: "Voucher deleted successfully!", status: res.status },
		});
	} catch (err) {
		dispatch({
			type: ERR_VOUCHERS,
			payload: { msg: err, status: err.response },
		});
	}
};

export const showLoading = (flag) => async (dispatch) => {
	dispatch({
		type: LOADING_VOUCHERS,
		payload: flag,
	});
}